import { SanGameConfig } from "../../../SanGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { TimelineMax, TweenLite, Power2, Back} from "gsap";
import { Point, BLEND_MODES } from "pixi.js";
import { ReelItemMap, IItemTransform, IReelItem } from "../../../engine/mapping/ReelItemMap";
import { ReelState } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { SanEngineController } from "../../../engine/SanEngineController";
import { SanSpriteSymbol } from "../../../engine/Symbol/SanSpriteSymbol";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { SanJumpDataSection } from "../../../server/data/ISanServerData";
import { SymbolData } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/SymbolData";
import { SoundConfig } from "../../../SoundConfig";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { SpinePlayer } from "../../../proto/SpinePlayer";
import { SanParsedGameData } from '../../../server/data/SanParsedGameData';

export interface WildItem extends IReelItem {
    ID:number;
    cont: PIXI.Container;
    seq: Sequence;
    seq_hot: Sequence;
    seq_hot_fx: Sequence;
    spine: SpinePlayer;
    seq_idle: Sequence;
    seq_land: Sequence;
    state:string;
    multValue:number;
    mult: PIXI.Sprite;
    timeline?: TimelineMax;
    toPos?: PIXI.Point;
    updatePos?:() => PIXI.Point;
    updateScale?:() => PIXI.Point;
    jumped:boolean;
}

interface WildAnimationJump {
    ID: number;
    mult?: number;
    to: SanJumpDataSection;
    duration?: number;
}

export class JumpingWildController extends ReelItemMap {

    private static _instance: JumpingWildController;

    public static get instance(): JumpingWildController {
        return this._instance;
    }

    public get items():WildItem[]{
        return this._items as WildItem[];
    }

    public individualToShow(ID:number):PIXI.DisplayObject{
        const item: WildItem = this.getExistingItem(ID)!;
        if(item.multValue > 1){
            item.spine.play({name:"X" + item.multValue + "_Idle",loop:true})
            return item.spine;
        }else{
            return item.seq;
        }
    }

    constructor() {
        super();
        JumpingWildController._instance = this;
        StageManager.getLayer(SanGameConfig.instance.LAYERS.REEL_SUPER_OVERLAY.name).addChild(this);
    }

    public changeMult(ID: number, multValue: number): void {
        if(!multValue || multValue <= 1 || !this.getExistingItem(ID)) return;

        const item: WildItem = this.getExistingItem(ID)!;

        if(item.multValue === multValue) return;

        if(item.multValue === 1){
            item.seq.visible = false;
            item.spine.visible = true;
        }

        item.seq_hot_fx.stop();
        item.seq_hot_fx.playAnimation({ 
            duration:0.5,
            onStart:() => { 
                item.seq_hot.visible = true;
                item.seq_hot_fx.visible = true;
                item.seq_hot.alpha = 1;
                item.seq_hot_fx.alpha = 1;

            }, onUpdate: () => { 
                var upAlpha:number = 1-item.seq_hot_fx.timeline!.progress();
                item.seq_hot.alpha = Math.max(0.45,upAlpha);
                item.seq_hot_fx.alpha = upAlpha;
            },
            onCompleteCallback:() => {
                item.seq_hot_fx.visible = false;
                // item.seq_hot.visible = false;
            }
        })

        item.multValue = multValue;
        item.spine.play({name:"X"+item.multValue}).eventCallback("onComplete",() => item.spine.play({name:"X" + item.multValue + "_Idle",loop:true}));

    }

    public itemExists(reelID:number, rowID:number):number{
        return !!super.getExistingItem(reelID,rowID) ? (super.getExistingItem(reelID,rowID) as WildItem).ID : -1;
    }

    public JumpTo(conf: WildAnimationJump,noShake:boolean = false,noSound:boolean = false): TimelineMax {
        const item: WildItem = this.getExistingItem(conf.ID)!;

        this.individualToShow(item.ID).visible = true;
        this.individualToShow(item.ID).alpha = 1;
        const fromPosition: Point = item.cont.position as Point;

        const reelC:SanEngineController = SanEngineManager.getReel(conf.to.reel);
        const toPosition: Point = reelC.getCurrentStatePositionMap(item.cont)[conf.to.row + reelC.overflowDirection];
        item.updatePos = () => reelC.getCurrentStatePositionMap(item.cont)[conf.to.row + reelC.overflowDirection];// null!;
        item.updateScale = undefined;

        if(item.timeline && item.timeline.isActive()){
            item.jumped = false;
            item.timeline.eventCallback("onComplete", () => {
                item.jumped = true;
                item.ReelID = conf.to.reel;
                item.SymID = conf.to.row;
                this.updateItemTransform(item,true);
                if(item.multValue > 1)
                    item.spine.play({name:"X"+item.multValue}).eventCallback("onComplete",() => item.spine.play({name:"X" + item.multValue + "_Idle",loop:true}));
                else
                    item.seq_land.playAnimation({onStart:() => item.seq_land.alpha = 1, onCompleteCallback:() => item.seq_land.alpha = 0});
            })
        }else{
            item.timeline = Helper.timeLineKiller(item.timeline!,new TimelineMax({
                onStart:() => {
                    item.jumped = false;
                },
                onComplete: () => {
                    item.jumped = true;
                    item.ReelID = conf.to.reel;
                    item.SymID = conf.to.row;
                    this.updateItemTransform(item,true);
                        if(item.multValue > 1){
                            item.spine.play({name:"X"+item.multValue}).eventCallback("onComplete",() => item.spine.play({name:"X" + item.multValue + "_Idle",loop:true}));
                        }
                    else
                        item.seq_land.playAnimation({onStart:() => item.seq_land.alpha = 1, onCompleteCallback:() => item.seq_land.alpha = 0});
                },
            }));
        }

        // if(!noShake)
        //     item.timeline.add(AnimationEffects.Shake({
        //         obj:item.cont,
        //         duration:0.35,
        //         hertz:70,
        //         x:1,
        //         y:1,
        //         Intensity:8,
        //         // positionCb: () => toPosition,
        //         ease: Power2.easeIn,
        //         // reverseEase:true
        //     }))

        if(item.ID == 0 && !noSound){
            item.timeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_JUMPINGWILD_MOVE));
        }

        const e:any = Back.easeIn.config(2.43);
        item.timeline.fromTo(item.cont.position, conf.duration ? conf.duration : 0.3,
            {x:fromPosition.x, y:fromPosition.y},
            { x:toPosition.x,y:toPosition.y, ease:e }
        );

        item.timeline.add(() => {
                item.seq_hot_fx.stop();
                item.seq_hot_fx.playAnimation({ 
                    duration:0.5,
                    onStart:() => { 
                        item.seq_hot.visible = true;
                        item.seq_hot_fx.visible = true;
                        item.seq_hot.alpha = 1;
                        item.seq_hot_fx.alpha = 1;
        
                    }, onUpdate: () => { 
                        var upAlpha:number = 1-item.seq_hot_fx.timeline!.progress();
                        item.seq_hot.alpha = Math.max(0.45,upAlpha);
                        item.seq_hot_fx.alpha = upAlpha;
                    },
                    onCompleteCallback:() => {
                        item.seq_hot_fx.visible = false;
                        // item.seq_hot.visible = false;
                    }
                })
            }
        );


        item.timeline.play();
        return item.timeline;
    }

    public jumpDelay(id:number):number{
        const item: WildItem = this.getExistingItem(id)!;
        return item.timeline ? item.timeline!.duration() - item.timeline!.time() : 0 ;
    }

    public createJumpWild(reelID: number, symID: number,alpha:number = 1): WildItem {
        const item: WildItem = this.getItem(this.items.length, reelID, symID)!;
        item.cont.visible = !!alpha;
        this.updateItemTransform(item);
        this.individualToShow(item.ID).alpha = alpha;
        return item;
    }

    public MergeWithReel(itemID:number, value:boolean, quick:boolean = false):void {
        const item: WildItem = this.getExistingItem(itemID)!;
        const sym:SanSpriteSymbol = SanEngineManager.getReel(item.ReelID).getSymbol(item.SymID)!;

        if(value){

            sym.isFSMarked(0);
            
            if(!quick){

                if(!sym.isScatter){
                    sym.setJWValue(item.multValue,0.1)
                }

                item.timeline = Helper.timeLineKiller(new TimelineMax({onComplete:() => {
                    if(sym.isScatter){
                        item.seq_idle.alpha =  0.4;
                    }else{
                        item.seq_idle.stop();
                        item.seq_idle.alpha = 0;
                        item.cont.visible = false;
                    }
                   
                }}));
                item.timeline.to(this.individualToShow(item.ID),0.1, {alpha:sym.isScatter ? 0.4 : 0, ease: Power2.easeIn },0);
                item.timeline.to(item.seq_idle,0.1, {alpha:sym.isScatter ? 0.4 : 0, ease: Power2.easeIn },0);
                item.timeline.to(item.seq_hot,0.1, {alpha:sym.isScatter ? 0.4 : 0, ease: Power2.easeIn },0);
                item.timeline.play();
            }else{

                sym.setJWValue(item.multValue,0)

                this.individualToShow(item.ID).alpha = 0;

                item.seq_idle.alpha = 0;
                item.cont.visible = false;
            }
        } 
        else{

            sym.changeState({ state:ReelSymbolStates.SPIN, duration: quick ? 0 : undefined})
            sym.hideMult();

            if(!item.seq_idle.isActive){
                item.seq_idle.playAnimation({ onCompleteCallback:() => this.playIdleLoop(item.seq_idle) }).add(TweenLite.fromTo(item.seq_idle,0.25,{alpha:0}, {alpha:1}),0);
            }
            
            this.individualToShow(item.ID).alpha = 1;
            item.cont.visible = true;
            item.seq_hot.visible = false;
        }
    }

    private playIdleLoop(seq:Sequence):void{
        seq.alpha = 0;
        seq.playAnimation({ onCompleteCallback:() => this.playIdleLoop(seq), onStart:() => seq.alpha = 1 }).delay(2+Math.random()*4)
    }

    public forceResize():void{
        this.items.forEach(i => this.updateItemTransform(i)) 
    }

    // Functions
    protected updateItemTransform(item: WildItem, useMap:boolean = true): void {
        if (item == undefined) return;
        const transformData: IItemTransform = this.getSymbolTransformData(item, item.cont, useMap ,  ReelState.STEP)!;
        item.cont.scale =  item.updateScale? item.updateScale() :  transformData.scale;
        item.cont.position = item.updatePos? item.updatePos() : transformData.position;
    }

    public getExistingItem(ID:number):WildItem | undefined{
        for(let id:number = 0; id < this._items.length; id++){
            if(this._items[id] && (this._items[id] as WildItem).ID == ID) return this._items[id] as WildItem;
        }
        return undefined;
    }

    protected getItem(ID:number, reelID: number, symID: number): WildItem {
        let item: WildItem | undefined = this.getExistingItem(ID) as WildItem;
        if (item) return item;

        const seq:Sequence = Sequence.createSequence(GameResources.getTextures("Jumping_Wild/JW_4_Badge"))
        const seq_land:Sequence = Sequence.createSequence(GameResources.getTextures("JW_Landing"));
        const seq_idle:Sequence = Sequence.createSequence(GameResources.getTextures("JW_Idle"));

        const seq_hot_sym:Sequence = Sequence.createSequence((GameResources.getTextures("W_J/4/JW_BG")));
        const seq_hot_sym_fx:Sequence = Sequence.createSequence((GameResources.getTextures("Hot_Zone")));

        const spine:SpinePlayer = new SpinePlayer("JW_Multi");
        seq.alpha = 1;
        seq_idle.alpha = 0;
        seq_hot_sym.blendMode = BLEND_MODES.ADD
        seq_hot_sym_fx.blendMode = BLEND_MODES.ADD
        seq_land.blendMode = BLEND_MODES.ADD;
        seq_idle.blendMode = BLEND_MODES.ADD;

        item =  <WildItem>super.createItem(reelID, symID, {
            ID:this.children.length,
            cont: new PIXI.Container(),
            seq: seq,
            spine:spine,
            seq_hot: seq_hot_sym,
            seq_hot_fx: seq_hot_sym_fx,
            seq_land:seq_land, 
            seq_idle:seq_idle, 
            jumped:false,
            multValue:1 } as WildItem );
            
        item.cont.zIndex = this.children.length;

        item.cont.addChild(seq_hot_sym);
        
        item.cont.addChild(seq);
        item.cont.addChild(spine);

        item.cont.addChild(seq_land);
        item.cont.addChild(seq_idle);

        item.cont.addChild(seq_hot_sym_fx);
        
        this._items.push(item);
        this.addChild(item.cont);
        this.updateItemTransform(item);
        this.sortChildren();
        return item;
    }

    public cleanItems(): void {
        super.reset();
    }

    public moveResWin():void{
        this.items.forEach(((i,indx) => {
            i.timeline = Helper.timeLineKiller(i.timeline!, new TimelineMax());
            const toPosition: PIXI.Point = this.fetchResPos(indx,i.cont);
            i.timeline.to(i.cont.position, 0.5 , { x: toPosition!.x, y: toPosition!.y /*, (ease: Power2.easeInOut */ });//,ease:Back.easeInOut});
        }));
    }

    private fetchResPos(indx:number,disp:PIXI.DisplayObject):PIXI.Point{
        const toPosition: PIXI.Point = SanEngineManager.getReel(2).getCurrentStatePositionMap(disp)[2];
        toPosition.x += indx * 20;
        toPosition.y += SymbolData.DEFAULT_SYMBOL.DIM.HEIGHT*0.5 + -indx*0.5;
        return toPosition;
    }

    protected onResize():void { }
}